import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { MainLayoutComponent } from './shared/components/main-layout/main-layout.component';
import { FederationShellComponent } from './shared/components/federation-shell/federation-shell.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    component: FederationShellComponent,
    children: [
      // Landing page — role selector (Espace Fédération / Espace Clubs)
      {
        path: 'accueil',
        loadChildren: () =>
          import('./pages/landing/landing.module').then((m) => m.LandingModule),
      },

      // Public auth routes — same login component, platform inferred from the URL
      {
        path: 'federation/auth',
        loadChildren: () =>
          import('./pages/auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: 'club/auth',
        loadChildren: () =>
          import('./pages/auth/auth.module').then((m) => m.AuthModule),
      },

      // Protected routes — wrapped in MainLayoutComponent + AuthGuard
      {
        path: '',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: 'federation',
            loadChildren: () =>
              import('./pages/federation/federation.module').then((m) => m.FederationModule),
          },
          {
            path: 'club',
            loadChildren: () =>
              import('./pages/club/club.module').then((m) => m.ClubModule),
          },
        ],
      },

      // Error pages — outside AuthGuard, no layout
      { path: 'unauthorized', component: UnauthorizedComponent },

      { path: '', redirectTo: 'accueil', pathMatch: 'full' },
      { path: '**', redirectTo: 'accueil' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
